export enum Tab {
  DataSources = 'data-sources',
  Portfolios = 'portfolios',
  Projects = 'projects',
  BoardSettings = 'board-settings',
  Workflows = 'workflows',
  Groups = 'groups',
  IntegrationHealthChecker = 'integration-health',
}

export interface State {
  activeTab: Tab;
}
